<script setup lang="ts">
import type { InvestigationCollectionItem } from '@nuxt/content'

export type LocationsSize = 'small' | 'medium' | 'large'

const props = defineProps<{
  article?: InvestigationCollectionItem
}>()

const { data: articles } = await useInvestigationArticles()
const { data: locations } = await useInvestigationLocations(props.article)
const { data: animals } = await useAnimals()

useProvideMapState(locations, animals, articles)

const container = ref<HTMLElement>()

const { width } = useElementSize(container)

const sizes = computed<{
  [key in LocationsSize]: boolean
}>(() => ({
  small: width.value < 800,
  medium: width.value >= 800 && width.value < 1000,
  large: width.value >= 1000,
}))

const size = computed<LocationsSize>(() => {
  if (sizes.value.small)
    return 'small'
  if (sizes.value.medium)
    return 'medium'
  return 'large'
})
const columnClasses = computed(() => {
  return {
    'grid-cols-1': sizes.value.small,
    'grid-cols-[1fr_20rem]': sizes.value.medium,
    'grid-cols-[1fr_26rem]': sizes.value.large,
  }
})
</script>

<template>
  <section
    ref="container"
    class="relative grid grid-rows-1 bg-white dark:bg-neutral-800 overflow-hidden"
    :class="columnClasses"
  >
    <LocationsMap :size="size" />
    <section v-if="!sizes.small" class="grid grid-rows-[auto_1fr] isolate">
      <header class="flex items-center px-2 py-4 border-b dark:border-b-neutral-700 border-b-neutral-200 shadow-xl z-10">
        <h2 class="font-heading text-2xl font-bold text-primary-800 dark:text-neutral-100">
          Locaties
        </h2>
        <div class="ml-auto">
          <LocationsListHeaderGroupByToggle />
        </div>
      </header>
      <LocationsList class="z-0" />
    </section>
  </section>
</template>
